import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PublicationModel} from '../../../models/publication.model';

@Component({
    selector: 'app-prints-report-table',
    templateUrl: './prints-report-table.component.html',
    styleUrls: ['./prints-report-table.component.scss']
})
export class PrintsReportTableComponent implements OnInit {
    pTable = {
        colNumber: 7,
        expandedRows: {}
    };

    @Input('filteredPublication')
    filteredPublication: PublicationModel[] = [];
    selectedPublication: PublicationModel[] = [];
    @Output('onPublicationSelected')
    onPublicationSelected = new EventEmitter<PublicationModel[]>();
    @Input() totalItems = 0;

    emitModel() {
        this.onPublicationSelected.emit(this.selectedPublication);
    }

    constructor() {
    }

    ngOnInit() {
    }


}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/generate-report/prints-report-table/prints-report-table.component.ts